import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import store from './store'
import Vuex from 'vuex'
import routes from './routes'
import VueCookies from 'vue-cookies'
import {HTTP} from "./api/api";

Vue.use(ElementUI, {locale});
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueCookies);


const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {

    if (to.path != '/login') {
        let token = sessionStorage.getItem('token');

        if (!token) {
            next({path: '/login'})
        } else {
            HTTP.defaults.headers.common.Authentication = token;
            next()
        }
    } else {
        next()
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js